export default "__VITE_ASSET__DeJUQXl3__"